import { createSelector } from 'reselect'
import { SelectorUtils } from '@nv/rc/Utils'
import _ from 'lodash'

const { selector } = SelectorUtils

export const selectItems = selector('airwayBills', 'items')
export const selectAirwayBillIds = index => createSelector(selectItems(), items => _.get(items, [index, 'ids']))
